import { render, staticRenderFns } from "./TableLists.vue?vue&type=template&id=c61996cc&scoped=true"
import script from "./TableLists.vue?vue&type=script&lang=js"
export * from "./TableLists.vue?vue&type=script&lang=js"
import style0 from "./TableLists.vue?vue&type=style&index=0&id=c61996cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61996cc",
  null
  
)

export default component.exports